//  import addressParser from "parse-address";
import { KeyboardEvent } from "react";

// import { FiberStatus } from "@/ui/constants/fiberStatus";
// import {
//   Address,
//   AddressLabelName,
//   PartialParsedAddress,
// } from "@/ui/types/api/session";

import { AddressLabelName,Address,PartialParsedAddress } from "../../ModalClass/types";
// import { UqualResponse } from "@/ui/types/checkAvailabilityKineticFiber";
// import { getGoogleFormattedAddress } from "@/ui/utils/google/googleMaps";
import { getGoogleFormattedAddress } from "../../utils/google/googleMaps";

export const isEnterKey = (event: KeyboardEvent) => event.key === "Enter";

export const formatPhoneNumber = (phoneNumberString: string) => {
  const cleaned = ("" + phoneNumberString).replace(/\D/g, "");
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? "+1" : "";
    return [intlCode, "-", match[2], "-", match[3], "-", match[4]].join("");
  }
  return null;
};

export async function parseAddressToComponents(
  address: string,
  address2?: string,
) {
  const parsedByParseAddress = parseCustomAddress(address, address2);

  const wordCountOfAddress = address.split(" ").length;
  const wordCountOfParsedAddress = Object.values(parsedByParseAddress)
    .filter(Boolean)
    .join(" ")
    .split(" ").length;
  if (Math.abs(wordCountOfAddress - wordCountOfParsedAddress) >= 2) {
    const parsedByGoogle = await getGoogleFormattedAddress({ address });
    return parsedByGoogle.address;
  } else return parsedByParseAddress;
}

export function parseCustomAddress(
  address: string,
  address2?: string,
): Address {
  //const parsed = addressParser.parseLocation(address);
  const parsed = "";
  // let a1 = "";
  // if (parsed?.number) {
  //   a1 += parsed?.number;
  // }
  // if (parsed?.prefix) {
  //   a1 += " " + parsed?.prefix;
  // }
  // if (parsed?.street) {
  //   a1 += " " + parsed?.street;
  // }
  // if (parsed?.type) {
  //   a1 += " " + parsed?.type;
  // }
  // if (parsed?.suffix) {
  //   a1 += " " + parsed?.suffix;
  // }

  return {
    addressLine1:"",// a1.trim(),
    addressLine2: address2 || "",
    city:"",// parsed?.city || "",
    state:"",// parsed?.state || "",
    postalCode:"",// parsed?.zip || "",
    // addressLine1:"",// a1.trim(),
    // addressLine2: address2 || "",
    // city: parsed?.city || "",
    // state: parsed?.state || "",
    // postalCode: parsed?.zip || "",
  };
}

// export const processFiberStatus = (uQualResponse: UqualResponse) => {
//   let result: string = "";
//   switch (true) {
//     case uQualResponse == null || uQualResponse?.outOfNetwork:
//       result = FiberStatus.NO_FIBER_COPPER;
//       break;

//     case uQualResponse?.upgradeToFiber:
//       result = FiberStatus.UPGRADE_TO_FIBER;
//       break;

//     case uQualResponse?.fiberAvailableNow:
//       result = FiberStatus.FIBER_AVAILABLE;
//       break;

//     case uQualResponse?.fiberComingSoon: {
//       result = FiberStatus.FIBER_COMING;
//       break;
//     }

//     case uQualResponse?.noFiberNoUpgradeAvailable:
//       result = FiberStatus.NO_FIBER_NO_UPGRADE_AVAILABLE;
//       break;

//     case uQualResponse?.noFiberUpgradeAvailable:
//       result = FiberStatus.NO_FIBER_UPGRADE_AVAILABLE;
//       break;

//     case uQualResponse?.copperAvailable:
//       result = FiberStatus.NO_FIBER_COPPER_AVAILABLE;
//       break;

//     case uQualResponse?.errorMessage !== undefined &&
//       uQualResponse?.errorMessage !== "": {
//       result = FiberStatus.FIBER_UNKNOWN;
//       break;
//     }

//     default:
//       return FiberStatus.FIBER_UNKNOWN;
//   }

//   return result as FiberStatus;
// };

// to handle "parse-address" edge cases
export const fixedPreFillDetails = async (
  parsedAddress: PartialParsedAddress,
  { address, unit }: { address?: string; unit?: string },
) => {
  //parsed address library is parsing the address with the city name as AddressLine1.
  //Hence, this logic is to prefill the address fields using google formatted address
  const parsedByGoogle = await getGoogleFormattedAddress({ address });
  if (
    parsedByGoogle.address &&
    parsedByGoogle.address.city?.trim() &&
    parsedByGoogle.address.addressLine1?.trim() &&
    parsedByGoogle.address.postalCode?.trim() &&
    parsedByGoogle.address.state?.trim()
  ) {
    parsedAddress = parsedByGoogle.address;
  }
  if (
    parsedAddress?.city === "" &&
    parsedAddress?.state === "" &&
    parsedAddress?.postalCode === ""
  ) {
    const userGivenInput = address || "";
    const addressLine2 = unit || "";

    const [addressLine1, city, state, postalCode] =
      userGivenInput.split(",").map((part: string) => part.trim()) || [];

    // issue :  "&" character is not passed to the street field in the transition page. All types of characters should be passed.
    // fix : to maintain the same position of speacial charectors, replace following special charectors with placeholder before parsing and replace placeholder text after parsing.
    if (parsedAddress?.addressLine1 === "") {
      // special charectors which fails address parser parsing functionality
      const specialChars = [
        { char: "&", name: "U0026" },
        { char: "@", name: "U0040" },
      ];

      let placeholderAddedText = userGivenInput;
      specialChars.forEach(specialChar => {
        placeholderAddedText = placeholderAddedText.replaceAll(
          new RegExp(specialChar.char, "g"),
          specialChar.name,
        );
      });

      parsedAddress = await parseAddressToComponents(
        placeholderAddedText,
        addressLine2,
      );

      // only updating address lines 1, 2, and city, since there is no possibility to have state, and zip special characters.
      const addressLabelToUpdate: AddressLabelName[] = [
        "addressLine1",
        "addressLine2",
        "city",
      ];
      specialChars.forEach(specialChar => {
        addressLabelToUpdate.forEach(label => {
          parsedAddress[label] = parsedAddress[label]?.replaceAll(
            new RegExp(specialChar.name, "g"),
            specialChar.char,
          );
        });
      });
    } else {
      // issue : trimmed street address
      // fix : use user given input instead parsed street address
      parsedAddress = {
        addressLine1: addressLine1 || "",
        addressLine2: addressLine2,
        city: city || "",
        state: state || "",
        postalCode: postalCode || "",
      };
    }
  }

  return parsedAddress;
};

// is invalid address - if any required component is missing or state and zip mismatch
export const isInvalidAddress = (
  parsedAddress: Address | undefined,
  isZipStateMismatch: Boolean,
) => {
  if (!parsedAddress) return true;
  return (
    parsedAddress.addressLine1 === "" ||
    parsedAddress.city === "" ||
    parsedAddress.state === "" ||
    parsedAddress.postalCode === "" ||
    isZipStateMismatch
  );
};
